import React from 'react';
import { backgroundCSS } from './Background.css';
import { leftVector } from '../../../../../Assets/Images';

function Background(props) {
    return (
        <div css={backgroundCSS()}>
            <img src={leftVector} className='absolute left-0' style={{ top: "42px", width: 'calc(3rem + 9vw)' }} />
            <div className='absolute flex flex-column gap-6' style={{ right: "2.5vw", top: "230px" }}>
                <div className='relative w-full flex justify-content-center'>
                    <div className='backgroundLine absolute' style={{  }} />
                </div>
                <div className='' style={{ color: "#22EC9A", fontSize: "calc(1rem + 2.8vw)", width: "calc(2rem + 14vw)" }}>
                    Confiable y seguro
                </div>
            </div>
            <img src={leftVector} className='absolute' style={{ right: "-24.68px", bottom: "-2px", rotate: "180deg", scale: "0.8", width: 'calc(3rem + 9.5vw)' }} />
            <div className='absolute flex flex-column' style={{ left: "6vw", bottom: "77px", gap: "10rem" }}>
                <div className='flex flex-column gap-3 BottomLeftText'>
                    <div className='flex align-items-center gap-5'>
                        <div style={{ width: "31px", height: "1px", background: "#34C6F1" }} />
                        <div style={{ }}>Fácil</div>
                    </div>
                    <div className='flex align-items-center gap-5'>
                        <div style={{ width: "31px", height: "1px", background: "#34C6F1" }} />
                        <div style={{ }}>Claro</div>
                    </div>
                    <div className='flex align-items-center gap-5'>
                        <div style={{ width: "31px", height: "1px", background: "#34C6F1" }} />
                        <div style={{ }}>Digital</div>
                    </div>
                </div>
                <div className='relative w-full'>
                    <div className='backgroundLine absolute' style={{ right: "-68px" }} />
                </div>
            </div>
        </div>
    );
}

export { Background };